import {
  ProForm,
  ProFormCheckbox,
  ProFormDigit,
  ProFormDigitRange,
  ProFormGroup,
  ProFormSelect,
  ProFormText,
  ProFormTextArea,
  ProFormList,
} from "@ant-design/pro-components";
import { Button, Card, Switch, Checkbox, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useState } from "react";
import { DeleteNotification } from "../../ClientInfo/ClientsPopover";
import {
  updateProduct,
  fetchWarehouseStock,
  updateDoorType,
  deleteProduct,
  createWarehouseForProduct,
} from "../utils/fetch";

const FullProductInfo = ({ data, accessories = [] }) => {
  const [readonly, setReadonly] = useState(true);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteWarehouseToo, setDeleteWarehouseToo] = useState(false);
  const [selectedAccessories, setSelectedAccessories] = useState([]);
  const [warehouseStock, setWarehouseStock] = useState([]);

  const [form] = useForm();

  useEffect(() => {
    fetchWarehouseStock(setWarehouseStock);
  }, []);

  const handleDelete = () => {
    deleteProduct(data._id, deleteWarehouseToo);
  };

  const handleCreateWarehouse = async () => {
    try {
      const res = await createWarehouseForProduct(data._id);
      const { warehouseMaterialId, materialName, created } = res.data;

      form.setFieldsValue({ warehouseMaterialId });

      if (created) {
        fetchWarehouseStock(setWarehouseStock);
      }

      message.success(
        created
          ? `Создано: ${materialName}`
          : `Привязано к существующему: ${materialName}`
      );
    } catch (e) {
      message.error(e.response?.data?.message || "Ошибка при создании SKU");
    }
  };

  const handleSave = (value) => {
    const body = {
      name: value.name,
      costPrice: value.costPrice,
      price: value.price,
      description: value.description,
      ...(data.doorType && {
        minWidth: value.width ? value.width[0] : null,
        maxWidth: value.width ? value.width[1] : null,
        minHeight: value.height ? value.height[0] : null,
        maxHeight: value.height ? value.height[1] : null,
        thickness: value.thickness,
        doorStyle: value.doorStyle,
        isSlidingDoor: value.isSlidingDoor,
        doorCovering: value.doorCovering,
      }),
      warehouseMaterialId: value.warehouseMaterialId || null,
      accessories: selectedAccessories,
    };

    updateProduct(data._id, body);

    if (data.doorType && value.compositionRules) {
      updateDoorType(data.doorType._id, {
        compositionRules: JSON.stringify(value.compositionRules),
      });
    }
  };

  // Определяем, есть ли привязка к складу
  const hasWarehouseLink = !!data.warehouseMaterialId;

  return (
    <Card>
      {showDelete && (
        <DeleteNotification
          content={
            <>
              <p>Вы точно хотите удалить товар?</p>
              <p>
                <b>{data.name}</b>
              </p>
              {hasWarehouseLink && (
                <div style={{ marginTop: 12 }}>
                  <Checkbox
                    checked={deleteWarehouseToo}
                    onChange={(e) => setDeleteWarehouseToo(e.target.checked)}
                  >
                    Также удалить позицию на складе снабжения
                  </Checkbox>
                  <p
                    style={{
                      fontSize: 12,
                      color: "#999",
                      marginTop: 4,
                      marginBottom: 0,
                    }}
                  >
                    Удалится только если остаток = 0 и нет других товаров с этой
                    привязкой
                  </p>
                </div>
              )}
            </>
          }
          onClose={() => {
            setShowDelete(false);
            setDeleteWarehouseToo(false);
          }}
          onSubmit={handleDelete}
        />
      )}
      <Switch
        style={{
          marginBottom: 16,
        }}
        checked={readonly}
        checkedChildren="Ред."
        unCheckedChildren="Просм."
        onChange={setReadonly}
      />
      <ProForm
        form={form}
        readonly={readonly}
        name="validate_other"
        initialValues={{
          width: data.doorType ? [data.minWidth, data.maxWidth] : undefined,
          height: data.doorType ? [data.minHeight, data.maxHeight] : undefined,
          name: data.name || "",
          price: data.price || 0,
          costPrice: data.costPrice || 0,
          description: data.description || "",
          thickness: data.doorType ? data.thickness : undefined,
          doorStyle: data.doorType ? data.doorStyle : undefined,
          isSlidingDoor: data.doorType ? data.isSlidingDoor : undefined,
          doorCovering: data.doorType ? data.doorCovering : undefined,
          warehouseMaterialId: data.warehouseMaterialId || null,
          compositionRules: data.doorType?.compositionRules || [],
        }}
        onFinish={(value) => handleSave(value)}
        submitter={{
          render: () => {
            return [];
          },
        }}
      >
        <ProFormGroup>
          <ProFormText
            width="lg"
            name="name"
            label="Наименование"
            allowClear={false}
            placeholder="Наименование"
            rules={[
              {
                required: true,
                message: "Обязательное поле",
              },
            ]}
          />
        </ProFormGroup>
        {data.doorType && (
          <div>
            <div
              style={{
                display: "flex",
              }}
            >
              <ProFormGroup label="Высота">
                <ProFormDigitRange
                  placeholder={"Высота"}
                  name="height"
                  rules={[
                    {
                      required: true,
                      message: "Обязательное поле",
                    },
                  ]}
                />
              </ProFormGroup>
              <div style={{ width: 30 }}></div>
              <ProFormGroup
                label="Ширина"
                style={{
                  marginRight: 30,
                }}
              >
                <ProFormDigitRange
                  placeholder={"Ширина"}
                  name="width"
                  rules={[
                    {
                      required: true,
                      message: "Обязательное поле",
                    },
                  ]}
                />
              </ProFormGroup>
            </div>
            <div className="d-flex">
              <ProFormGroup
                style={{
                  marginRight: 10,
                }}
              >
                <ProFormSelect
                  allowClear={false}
                  label="Толщина"
                  name="thickness"
                  placeholder="Толщина"
                  rules={[
                    {
                      required: true,
                      message: "Обязательное поле",
                    },
                  ]}
                  options={[
                    {
                      value: 42,
                    },
                    {
                      value: 57,
                    },
                  ]}
                />
              </ProFormGroup>
              <ProFormGroup
                style={{
                  marginRight: 10,
                }}
              >
                <ProFormSelect
                  allowClear={false}
                  label="Вид двери"
                  name="doorStyle"
                  placeholder="Толщина"
                  rules={[
                    {
                      required: true,
                      message: "Обязательное поле",
                    },
                  ]}
                  options={[
                    {
                      value: "SINGLE_DOORS",
                      label: "Одностворчатые",
                    },
                    {
                      value: "DOUBLE_DOORS",
                      label: "Двустворчатые",
                    },
                  ]}
                />
              </ProFormGroup>
            </div>
            <div>
              {" "}
              <ProFormGroup
                style={{
                  marginRight: 10,
                }}
              >
                <ProFormSelect
                  allowClear={false}
                  label="Покрытие двери"
                  name="doorCovering"
                  placeholder="Покрытие двери"
                  rules={[
                    {
                      required: true,
                      message: "Обязательное поле",
                    },
                  ]}
                  options={[
                    {
                      value: "PRIMED",
                      label: "Грунтованные",
                    },
                    {
                      value: "VENEERED",
                      label: "Шпонированные",
                    },
                    {
                      value: "MIRROR",
                      label: "Зеркальные",
                    },
                    {
                      value: "PAINTED",
                      label: "Крашенные",
                    },
                  ]}
                />
              </ProFormGroup>
            </div>
            <div>
              <ProFormGroup>
                <ProFormCheckbox name="isSlidingDoor">
                  Раздвижной дверь
                </ProFormCheckbox>
              </ProFormGroup>
            </div>
          </div>
        )}

        {data.doorType && (
          <Card
            size="small"
            title="Состав двери (настройки типа двери)"
            style={{ marginBottom: 24, padding: 10 }}
          >
            <ProFormList
              name="compositionRules"
              creatorButtonProps={{
                position: "bottom",
                creatorButtonText: "Добавить материал в состав",
              }}
            >
              <ProFormGroup>
                <ProFormSelect
                  name="materialId"
                  label="Материал"
                  width="lg"
                  showSearch
                  allowClear
                  options={accessories.map((acc) => ({
                    label: `${acc.name} (${acc.unit}) - ${acc.costPrice} тг`,
                    value: acc._id,
                  }))}
                  rules={[{ required: true, message: "Обязательное поле" }]}
                />
                <ProFormText
                  name="materialNameSnapshot"
                  label="Название в списке (для отображения)"
                  width="md"
                  rules={[{ required: true, message: "Обязательное поле" }]}
                />
              </ProFormGroup>
              <ProFormGroup>
                <ProFormSelect
                  name="calculationType"
                  label="Тип расчёта"
                  width="sm"
                  options={[
                    { value: "PERIMETER", label: "По периметру" },
                    { value: "FIXED", label: "Фиксированное кол-во" },
                    {
                      value: "HINGES_CALC_42",
                      label: "Расчёт петель (Серия 42)",
                    },
                    {
                      value: "HINGES_CALC_57",
                      label: "Расчёт петель (Серия 57)",
                    },
                  ]}
                  rules={[{ required: true, message: "Обязательное поле" }]}
                />
                <ProFormDigit
                  name="fixedQuantity"
                  label="Фикс. кол-во"
                  width="xs"
                />
                <ProFormSelect
                  name="colorBehavior"
                  label="Цвет берем из..."
                  width="md"
                  options={[
                    { value: "NONE", label: "Цвет не важен" },
                    {
                      value: "FROM_ORDER_ALUMINIUM",
                      label: "Цвета алюминия из заказа",
                    },
                  ]}
                />
                <ProFormCheckbox
                  name="openingBehavior"
                  label="Зависит от открывания?"
                />
              </ProFormGroup>
            </ProFormList>
          </Card>
        )}

        {!data.doorType &&
          !["Услуга", "Монтаж", "Доставка"].includes(
            data.productType?.name
          ) && (
            <div className="d-flex align-items-end">
              <div style={{ flex: 1 }}>
                <ProFormSelect
                  name="warehouseMaterialId"
                  label="Связь со складом снабжения"
                  placeholder="Связь со складом снабжения"
                  showSearch
                  allowClear
                  options={warehouseStock.map((stock) => ({
                    label: `${stock.materialName} (${stock.unit})`,
                    value: stock._id,
                  }))}
                />
              </div>
              {!form.getFieldValue("warehouseMaterialId") && !readonly && (
                <Button
                  type="primary"
                  onClick={handleCreateWarehouse}
                  style={{ marginBottom: 24, marginLeft: 8 }}
                >
                  Создать на складе
                </Button>
              )}
            </div>
          )}

        <div className="d-flex">
          <ProFormGroup
            style={{
              marginRight: 10,
            }}
          >
            <ProFormDigit
              label="Цена"
              name="price"
              placeholder="Цена"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            />
          </ProFormGroup>
          <ProFormGroup>
            <ProFormDigit
              label="Себестоимость"
              name="costPrice"
              placeholder="Себестоимость"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            />
          </ProFormGroup>
        </div>
        <ProFormGroup>
          <ProFormTextArea
            label="Примечание"
            name="description"
            placeholder="Примечание"
          />
        </ProFormGroup>
        {!readonly && (
          <ProFormGroup
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              style={{
                backgroundColor: "red",
                color: "white",
              }}
              onClick={() => {
                setShowDelete(true);
              }}
            >
              Удалить
            </Button>
            <Button
              onClick={() => {
                setReadonly(true);
                form.resetFields();
                setSelectedAccessories(
                  data?.accessories.map((a) => a._id) || []
                );
              }}
            >
              Отменить
            </Button>
            <Button type="primary" htmlType="submit">
              Сохранить
            </Button>
          </ProFormGroup>
        )}
      </ProForm>
    </Card>
  );
};

export default FullProductInfo;